import { translate } from "../../util/translate"

export const paymentHeader = [
  {
    text: translate['financial.payment.label.createdAt'],
    value: 'created_at',
    width: '10vw',
  },
  {
    text: translate['financial.payment.label.type'],
    value: 'type',
    width: '5vw',
  },
  {
    text: translate['financial.payment.label.host'],
    value: 'host_name',
    width: '10vw',
  },
  {
    text: translate['financial.payment.label.transferStatus'],
    value: 'status',
    width: '10vw',
  },
  {
    text: translate['financial.payment.label.value'],
    value: 'total',
    align: 'right',
    width: '5vw',
  },
]
